<template>
  <section class="visibility-modal">
    <div class="modal-overlay" @click="$emit('close')" />
    <transition name="fadeInModal">
      <div class="modal">
        <div class="visibility-modal__header">
          This box is visible for:
          <img
            class="visibility-modal_close-icon"
            src="@/assets/EndOfLife/closeIconDark.svg"
            alt="Close Icon"
            @click="$emit('close')"
          />
        </div>
        <div
          class="visibility-modal__body"
          v-on:click="
            editVisibility(
              'all',
              box.visibility.anonymous &&
                box.visibility.checkin &&
                box.visibility.precheckin
            )
          "
        >
          <div class="visibility-modal__item">All guests</div>
          <img
            class="visibility-modal__item"
            src="@/assets/EndOfLife/toggleEnabled.svg"
            alt="enabled"
            v-if="
              box.visibility.anonymous &&
              box.visibility.checkin &&
              box.visibility.precheckin
            "
          />
          <img
            class="visibility-modal__item"
            src="@/assets/EndOfLife/toggleDisabled.svg"
            alt="disabled"
            v-else-if="
              !(
                box.visibility.anonymous &&
                box.visibility.checkin &&
                box.visibility.precheckin
              )
            "
          />
        </div>
        <div
          class="visibility-modal__body"
          v-on:click="editVisibility(name, value)"
          v-bind:key="name"
          v-for="(value, name) in orderedArray"
        >
          <div class="visibility-modal__item">{{ formatName(name) }}</div>
          <img
            class="visibility-modal__item"
            src="@/assets/EndOfLife/toggleEnabled.svg"
            alt="enabled"
            v-if="value"
          />
          <img
            class="visibility-modal__item"
            src="@/assets/EndOfLife/toggleDisabled.svg"
            alt="disabled"
            v-else-if="!value"
          />
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  props: {
    box: Object,
  },
  data() {
    return {
      visibility: this.box.visibility,
    };
  },
  computed: {
    orderedArray: function () {
      let p = this.visibility.precheckin;
      let c = this.visibility.checkin;
      let a = this.visibility.anonymous;
      let orderedVisibility = { precheckin: p, checkin: c, anonymous: a };
      return orderedVisibility;
    },
  },
  mounted: function () {
    document.addEventListener("keydown", this.closeWindow);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.closeWindow);
  },
  methods: {
    closeWindow(e) {
      if (e.keyCode == 27) {
        this.$emit("close");
      }
    },
    editVisibility(name, value) {
      if (name == "all") {
        this.visibility =
          this.visibility.anonymous &&
          this.visibility.checkin &&
          this.visibility.precheckin
            ? { precheckin: false, checkin: false, anonymous: false }
            : { precheckin: true, checkin: true, anonymous: true };
        this.$emit("editVisibility", this.visibility);
      } else {
        this.visibility[name] = !value;
        this.$emit("editVisibility", this.visibility);
      }
    },
    formatName: function (name) {
      let computed = "";
      switch (name) {
        case "precheckin":
          computed = "Prechecked-in guests";
          break;
        case "checkin":
          computed = "Checked-in guests";
          break;
        case "anonymous":
          computed = "Guests from QR Code";
          break;
      }
      return computed;
    },
  },
};
</script>

<style scoped>
@supports (-ms-ime-align: auto) {
  .visibility-modal__header {
    margin-top: 10px;
  }
  .visibility-modal__body {
    margin-top: 15px;
  }
}
.visibility-modal {
  position: absolute;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-overlay {
  background-color: rgba(0, 0, 0, 0.8);
  z-index: -1;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.visibility-modal_close-icon {
  position: relative;
  bottom: 13px;
  width: 13px;
  scale: 2;
  left: 22px;
}

.modal {
  background-color: white;
  width: 300px;
  height: 200px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.visibility-modal__header {
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 30px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #707070;
}

.visibility-modal__body {
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707070;
}
.visibility-modal__item:first-child {
  margin-left: 47px;
}
.visibility-modal__item:last-child {
  margin-right: 47px;
  height: 20px;
  width: 40px;
}
</style>
